import moment from 'moment/moment';
import { message } from 'antd';

export default function checkPassengers({
  form,
  onSuccess,
  trans,
}) {
  const urlParams = new URLSearchParams(window.location.search);
  const passengers = form.getFieldValue('passengers');
  if (urlParams.get('seatFormation') !== 'completeBooking'
        && !passengers?.find((passenger) => moment().diff(moment(passenger?.birth_date), 'years') >= 18)) {
    form.setFields([{
      name: ['passengers', 0, 'birth_date'],
      errors: [trans('one_adult_passenger_required')],
    }]);
    return false;
  }

  const uniquePassengers = [];
  const duplicatePassengers = [];

  passengers.forEach((passenger, index) => {
    if (uniquePassengers.find(
      (uniquePassenger) => uniquePassenger?.id_number === passenger?.id_number,
    )) {
      duplicatePassengers.push({
        ...passenger,
        index,
      });
    } else {
      uniquePassengers.push(passenger);
    }
  });

  if (duplicatePassengers.length) {
    const underagePassengers = duplicatePassengers.filter((passenger) => passenger?.birth_date && moment().diff(moment(passenger?.birth_date), 'years') <= 10);
    if (underagePassengers.length) {
      form.setFields(underagePassengers.map((passenger) => ({
        name: ['passengers', passenger?.index, 'id_number'],
        errors: [trans('duplicate_child_passenger_code')],
      })));
      message.error({
        content: <div className="custom-message-content">{trans('duplicate_child_passenger_code_text')}</div>,
        className: 'custom-message-container',
        icon: null,
      });
      return false;
    }
  }

  onSuccess();
  return true;
}
